export const IS_HOTMART_DOMAIN = window.location.hostname.endsWith(String(process.env.APP_HOST))

export const IS_CUSTOM_DOMAIN = !IS_HOTMART_DOMAIN
